// extracted by mini-css-extract-plugin
export default {"themed-link":"themed-link_themed-link__h9Eu9"};